import type { ApiRoute, NoBody, NoPathParams, NoQueryParams, NoResponse } from "../api"
import type { NewsImageUploadUrlValues, NewsImageUploadUrlView } from "./NewsImageUpload"
import type { NewsItemAdd } from "./NewsItemAdd"
import type { NewsItemChange } from "./NewsItemChange"
import type { NewsItemView } from "./NewsItemView"
import type { NewsListView } from "./NewsListView"

export interface NewsItemPathParams {
	newsItemId: string
}

const newsItemsPath = "/news-items"
const newsItemPath = `${newsItemsPath}/:newsItemId`
const buildNewsItemUrl = ({ newsItemId }: NewsItemPathParams) => `${newsItemsPath}/${encodeURIComponent(newsItemId)}`

export const getNewsListRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, NewsListView> = {
	buildUrl: () => newsItemsPath,
	method: "get",
	path: newsItemsPath,
}

export const getNewsItemRoute: ApiRoute<NewsItemPathParams, NoQueryParams, NoBody, NewsItemView> = {
	buildUrl: buildNewsItemUrl,
	method: "get",
	path: newsItemPath,
}

export const addNewsItemRoute: ApiRoute<NoPathParams, NoQueryParams, NewsItemAdd, NewsItemView> = {
	buildUrl: () => newsItemsPath,
	method: "post",
	path: newsItemsPath,
}

export const updateNewsItemRoute: ApiRoute<NewsItemPathParams, NoQueryParams, NewsItemChange, NewsItemView> = {
	buildUrl: buildNewsItemUrl,
	method: "patch",
	path: newsItemPath,
}

export const reviewNewsItemRoute: ApiRoute<NewsItemPathParams, NoQueryParams, NoBody, NewsItemView> = {
	buildUrl: (pathParams) => `${buildNewsItemUrl(pathParams)}/review`,
	method: "post",
	path: `${newsItemPath}/review`,
}

export const publishNewsItemRoute: ApiRoute<NewsItemPathParams, NoQueryParams, NoBody, NewsItemView> = {
	buildUrl: (pathParams) => `${buildNewsItemUrl(pathParams)}/publish`,
	method: "post",
	path: `${newsItemPath}/publish`,
}

export const deleteNewsItemRoute: ApiRoute<NewsItemPathParams, NoQueryParams, NoBody, NoResponse> = {
	buildUrl: buildNewsItemUrl,
	method: "delete",
	path: newsItemPath,
}

const newsImageUploadUrlsPath = "/news-images/upload-urls"

export const createNewsImageUploadUrlRoute: ApiRoute<
	NoPathParams,
	NoQueryParams,
	NewsImageUploadUrlValues,
	NewsImageUploadUrlView
> = {
	buildUrl: () => newsImageUploadUrlsPath,
	method: "post",
	path: newsImageUploadUrlsPath,
}
